import { useState } from "react";
import { login, setToken } from "../api";
import { FONT, COLORS, GRADIENT, FontLink } from "../styles";

export default function LoginScreen({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [shake, setShake] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!username.trim() || !password) { setError("Please enter username and password"); return; }
    setLoading(true);
    setError("");
    try {
      const data = await login(username.trim(), password);
      setToken(data.token);
      onLogin();
    } catch (err) {
      setError(err.message);
      setShake(true);
      setTimeout(() => setShake(false), 600);
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: "100vh", background: COLORS.bg, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: FONT }}>
      <FontLink />
      <div style={{ width: 400, animation: shake ? "shake 0.4s ease" : "none" }}>
        <div style={{ textAlign: "center", marginBottom: 40 }}>
          <div style={{ width: 56, height: 56, background: GRADIENT, borderRadius: 14, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px", boxShadow: "0 4px 14px rgba(37,99,235,0.25)" }}>
            <span style={{ fontSize: 24, fontWeight: 800, color: "#fff" }}>S</span>
          </div>
          <div style={{ fontSize: 20, fontWeight: 700, color: COLORS.text }}>Starfish Advance</div>
          <div style={{ fontSize: 13, color: COLORS.muted, marginTop: 4 }}>Bank Analysis Platform</div>
        </div>
        <div style={{ background: COLORS.card, border: `1px solid ${COLORS.border}`, borderRadius: 12, padding: 32, boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}>
          <div style={{ marginBottom: 20 }}>
            <div style={{ fontSize: 13, fontWeight: 500, color: COLORS.textSecondary, marginBottom: 6 }}>Username</div>
            <input value={username} onChange={(e) => { setUsername(e.target.value); setError(""); }} onKeyDown={(e) => e.key === "Enter" && handleSubmit()} autoFocus disabled={loading}
              style={{ width: "100%", background: COLORS.bg, border: `1px solid ${error ? COLORS.red : COLORS.border}`, borderRadius: 8, padding: "10px 14px", fontSize: 14, color: COLORS.text, outline: "none", fontFamily: FONT, boxSizing: "border-box", transition: "border 0.2s" }} />
          </div>
          <div style={{ marginBottom: 24 }}>
            <div style={{ fontSize: 13, fontWeight: 500, color: COLORS.textSecondary, marginBottom: 6 }}>Password</div>
            <div style={{ position: "relative" }}>
              <input type={showPw ? "text" : "password"} value={password} onChange={(e) => { setPassword(e.target.value); setError(""); }} onKeyDown={(e) => e.key === "Enter" && handleSubmit()} disabled={loading}
                style={{ width: "100%", background: COLORS.bg, border: `1px solid ${error ? COLORS.red : COLORS.border}`, borderRadius: 8, padding: "10px 40px 10px 14px", fontSize: 14, color: COLORS.text, outline: "none", fontFamily: FONT, boxSizing: "border-box" }} />
              <button onClick={() => setShowPw(!showPw)} style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", color: COLORS.muted, cursor: "pointer", fontSize: 12, fontFamily: FONT, fontWeight: 500 }}>{showPw ? "Hide" : "Show"}</button>
            </div>
          </div>
          {error && <div style={{ background: COLORS.redLight, border: `1px solid #FECACA`, borderRadius: 8, padding: "10px 14px", fontSize: 13, color: COLORS.red, marginBottom: 16, textAlign: "center" }}>{error}</div>}
          <button onClick={handleSubmit} disabled={loading}
            style={{ width: "100%", background: loading ? COLORS.surface : GRADIENT, border: "none", borderRadius: 8, padding: 12, fontSize: 14, fontWeight: 600, color: loading ? COLORS.muted : "#fff", cursor: loading ? "not-allowed" : "pointer", fontFamily: FONT, boxShadow: loading ? "none" : "0 2px 8px rgba(37,99,235,0.25)" }}>
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </div>
      </div>
      <style>{`@keyframes shake { 0%,100%{transform:translateX(0)} 20%{transform:translateX(-8px)} 40%{transform:translateX(8px)} 60%{transform:translateX(-5px)} 80%{transform:translateX(5px)} }`}</style>
    </div>
  );
}
